(function( $, doc ) {
    "use strict";

    (function(){

        // OPEN menu
        $(".wpmudev-dots-dropdown").ready(function(){

            var $this = $(this),
                $button = $this.find(".wpmudev-dots-button");

            $button.on("click", function(){

                var $menu = $(this).next(".wpmudev-dots-menu");
                
                $(this).toggleClass("wpmudev-active");
                $menu.toggleClass("wpmudev-hidden");
                
            });

        });

        // ITEMS position
        $(document).ready(function(){

            var $this   = $(".wpmudev-list"),
                $table  = $this.find(".wpmudev-list-table"),
                $item   = $table.find(".wpmudev-table-body tr");

            var $totalItems = $item.length,
                $itemCount  = $totalItems;

            $item.each(function(){
                $(this).find('.wpmudev-body-menu').css('z-index', $itemCount);
                $itemCount--;
            });

        });

    }());
    
}( jQuery, document ));